import { TiMessages } from "react-icons/ti";
import { FaGlobeAsia } from "react-icons/fa";
import { BsFillTelephoneFill } from "react-icons/bs";


export const contactdetails = [
    {
        mode:'Chat on us',
        instruction:'Our friendly team is here to help.',
        details:'info@studynotion.com',
        icon:<TiMessages/>,
    },
    {
        mode:'Visit us',
        instruction:'Come and say hello at our office HQ.',
        details:'Akshya Nagar 1st Block 1st Cross, Rammurthy nagar, Bangalore-560016',
        icon:<FaGlobeAsia/>,
    },
    {
        mode:'Call us',
        instruction:'Mon - Fri From 8am to 5pm',
        details:'+123 456 7869',
        icon:<BsFillTelephoneFill/>,
    },
]